import { CloseOutlined, KeyboardArrowLeft, Search } from "@mui/icons-material";
import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import SelectSpecialization from "./SelectSpecialization";
import SearchDoctor from "../../Components/SearchDoctor";
import { IconButton, InputBase } from "@mui/material";
import { useState } from "react";

function DoctorsContent() {
  const {
    selectedDoctorBySearch,
    setShowDoctorsModal,
    setToSearchByDoctor,
    toSearchByDoctor,
    setSearchDoctor,
    searchDoctor,
  } = useConsultDoctorContext();

  const [isLoading, setIsLoading] = useState(false);

  const handleSearchDoctor = (e) => {
    setSearchDoctor(e.target.value);
    setIsLoading(true);
    //for refresh purposes of doctors list
    setTimeout(() => {
      setIsLoading(false);
    }, 0);
  };

  const handleCloseModal = () => {
    if (!selectedDoctorBySearch) {
      setToSearchByDoctor(!toSearchByDoctor);
    }
    setShowDoctorsModal(false);
  };

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <button disabled className="invisible">
              <KeyboardArrowLeft />
            </button>
            <div className="text-center text-md font-bold flex-1">Doctors</div>
            <button onClick={handleCloseModal}>
              <CloseOutlined />
            </button>
          </div>
        </div>
        <div className="w-full px-3">
          <div className="w-full mt-2 mb-2 flex align-center border">
            <IconButton disabled aria-label="search">
              <Search />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search doctor"
              value={searchDoctor}
              onChange={(e) => handleSearchDoctor(e)}
            />
          </div>
          <div className="flex flex-row">
            <div className="flex flex-col w-full">
              <SelectSpecialization hasAllOption={true} />
            </div>
          </div>
          <div className="mt-2">
            <SearchDoctor setIsLoading={setIsLoading} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DoctorsContent;
